import { LLM_PROVIDERS } from "./llmRoutingPolicy";
import {
  LLM_TELEMETRY_EVENT_NAME,
  getLlmOrchestrator,
} from "./llmOrchestrator";

/**
 * Backwards-compatible AI provider facade.
 * Existing UI flows import this module, while orchestration lives in llmOrchestrator.
 */
export const AI_PROVIDERS = {
  OLLAMA: LLM_PROVIDERS.OLLAMA,
  GEMINI: LLM_PROVIDERS.GEMINI,
  OPENAI: LLM_PROVIDERS.OPENAI,
};

export const getAIProviderManager = () => getLlmOrchestrator();

export const addAiTelemetryHook = (hook) =>
  getLlmOrchestrator().addTelemetryHook(hook);

export const removeAiTelemetryHook = (hook) =>
  getLlmOrchestrator().removeTelemetryHook(hook);

export const clearAiResponseCache = (options = {}) =>
  getLlmOrchestrator().clearCache(options);

export const getAiResponseCacheStats = () =>
  getLlmOrchestrator().getCacheStats();

export const AI_TELEMETRY_BROWSER_EVENT = LLM_TELEMETRY_EVENT_NAME;

export default getAIProviderManager;
